import { 
  signInWithPopup, 
  signOut as firebaseSignOut,
  onAuthStateChanged 
} from 'firebase/auth';
import { auth, googleProvider } from '../config/firebase';
import { getUserByEmail } from './userService';

// Sign in with Google
export const signInWithGoogle = async () => {
  try {
    console.log('Starting Google sign-in process...');
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user;
    
    console.log('Google Auth successful, user:', user.email);
    
    // Check if user exists in our Firestore database
    console.log('Checking if user exists in Firestore...');
    let existingUser = await getUserByEmail(user.email);
    
    if (!existingUser) {
      console.log('✅ New user signing up with Google - keeping them signed in for payment flow');
      // Create a user object for the signup flow, but keep them signed in
      const tempUser = {
        id: user.uid,
        fullName: user.displayName || user.email.split('@')[0],
        email: user.email,
        phone: '', // Will be collected during signup
        role: 'USER',
        subscriptionType: null, // Will be selected during signup
        profilePicture: user.photoURL || '',
        authProvider: 'google',
        googleUid: user.uid,
        isNewUser: true, // Flag to indicate this is a new user
        isTempUser: false // Don't prevent login, they need to stay signed in
      };
      
      return tempUser;
    } else {
      console.log('✅ Existing user found in Firestore:', existingUser.email);
      // Update existing user with Google info if needed
      if (!existingUser.googleUid) {
        console.log('Updating legacy user with Google info...');
        // This is a legacy user, update with Google info
        // You might want to update this in your userService
        existingUser.googleUid = user.uid;
        existingUser.authProvider = 'google';
        existingUser.profilePicture = user.photoURL || existingUser.profilePicture;
      }
    }
    
    const userData = {
      id: existingUser.id,
      fullName: existingUser.fullName,
      email: existingUser.email,
      phone: existingUser.phone,
      role: existingUser.role,
      subscriptionType: existingUser.subscriptionType,
      profilePicture: existingUser.profilePicture || user.photoURL || '',
      authProvider: 'google'
    };
    
    console.log('✅ Returning user data:', userData);
    return userData;
  } catch (error) {
    console.error('❌ Google sign-in error:', error);
    throw error;
  }
};

// Sign out
export const signOut = async () => {
  try {
    await firebaseSignOut(auth);
  } catch (error) {
    console.error('Sign out error:', error);
    throw error;
  }
};

// Listen to auth state changes
export const onAuthStateChange = (callback) => {
  return onAuthStateChanged(auth, callback);
};
